import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'

// Import des composants
import Login from '../views/Login.vue'
import List from '../views/List.vue'
import ExportLayout from '../views/Export/ExportLayout.vue'
import ExportVisites from '../views/Export/ExportVisites.vue'
import ExportPreChiffrages from '../views/Export/ExportPreChiffrages.vue'
import ListFilter from '../views/ListFilter.vue'
import Attribution from '../components/Attribution/Attribution.vue'
import Metrics from '../views/Metrics.vue'
import InitializationError from '../views/InitializationError.vue'
import LotLayout from '../views/Lot/LotLayout.vue'
import Informations from '../views/Lot/Informations.vue'
import NewVisit from '../views/Lot/NewVisit.vue'
import NewPreChiffrage from '../views/Lot/NewPreChiffrage.vue'
import ViewPreChiffrage from '../views/Lot/ViewPreChiffrage.vue'
import Timeline from '../views/Lot/Timeline.vue'
import ActionsAndWorks from '../views/Lot/ActionsAndWorks.vue'
import Visit from '../views/Lot/Visit.vue'
import KanbanVisites from '../views/KanbanVisites.vue'

// Import des composants d'administration
import AdminLayout from '../views/Admin/AdminLayout.vue'
import AdminDernieresVisites from '../views/Admin/AdminDernieresVisites.vue'
import AdminVisitManagers from '../views/Admin/AdminVisitManagers.vue'
import AdminPropertyDuplicates from '../views/Admin/AdminPropertyDuplicates.vue'
import AdminVisitsCleanup from '../views/Admin/AdminVisitsCleanup.vue'
import AdminBase64PhotosFix from '../views/Admin/AdminBase64PhotosFix.vue'
import AdminMandators from '../views/AdminMandators.vue'
import DatabaseSync from '../views/DatabaseSync.vue'
import VisitSyncToMssql from '../views/VisitSyncToMssql.vue'
import DoublonsVisites from '../views/DoublonsVisites.vue'
import PhotoImport from '../views/PhotoImport.vue'
import SqlQuery from '../views/SqlQuery.vue'
import ApiExplorer from '../views/ApiExplorer.vue'

const routes = [
  {
    path: '/connexion',
    name: 'connexion',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    redirect: '/connexion'
  },
  {
    path: '/logout',
    redirect: '/connexion'
  },
  {
    path: '/',
    name: 'home',
    component: { template: '<div></div>' },
    beforeEnter: (to, from, next) => {
      // Redirection vers la liste principale, sans filtres dans l'URL
      // (les filtres sont gérés dans localStorage)
      next({ name: 'PropertyPortfolio' })
    },
    meta: { requiresAuth: true }
  },
  {
    path: '/visites',
    name: 'MyVisites',
    component: List,
    props: {
      subject: 'visites',
      mapTotalToTitle: (total) => (loading) => !loading
        ? total > 1
          ? `${total} lots attribués`
          : `${total} lot attribué`
        : ''
    },
    meta: { requiresAuth: true }
  },
  {
    path: '/export',
    component: ExportLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: '/export/visites'
      },
      {
        path: 'visites',
        name: 'ExportVisites',
        component: ExportVisites,
        meta: { requiresAuth: true }
      },
      {
        path: 'pre-chiffrages',
        name: 'ExportPreChiffrages',
        component: ExportPreChiffrages,
        meta: { requiresAuth: true }
      }
    ]
  },
  {
    path: '/parc-immobilier',
    name: 'PropertyPortfolio',
    component: List,
    props: {
      subject: 'parcimmo',
      mapTotalToTitle: (total) => (loading) => !loading
        ? total > 1
          ? `${total} lots`
          : `${total} lot`
        : ''
    },
    meta: { requiresAuth: true }
  },
  {
    path: '/actions',
    name: 'ActionsList',
    component: List,
    props: {
      subject: 'actions',
      mapTotalToTitle: (total) => (loading) => !loading
        ? total > 1
          ? `${total} lots`
          : `${total} lot`
        : ''
    },
    meta: { requiresAuth: true }
  },
  {
    path: '/filters',
    name: 'ListFilters',
    component: ListFilter,
    meta: { requiresAuth: true }
  },
  {
    path: '/attribuer',
    name: 'Attribution',
    component: Attribution,
    meta: { requiresAuth: true }
  },
  {
    path: '/metrics',
    name: 'Metrics',
    component: Metrics,
    meta: { requiresAuth: true }
  },
  {
    path: '/kanban',
    name: 'KanbanVisites',
    component: KanbanVisites,
    meta: { requiresAuth: true }
  },
  {
    path: '/init/erreur',
    name: 'InitError',
    component: InitializationError,
    meta: { requiresAuth: true }
  },

  // ── Redirects de rétrocompatibilité pour les anciennes URLs admin ────────
  { path: '/database-sync',        redirect: '/admin/database-sync' },
  { path: '/visit-sync-to-mssql',  redirect: '/admin/visit-sync-mssql' },
  { path: '/doublons-visites',     redirect: '/admin/doublons-visites' },
  { path: '/api-explorer',         redirect: '/admin/api-explorer' },

  // ── Zone d'administration ────────────────────────────────────────────────
  // Accessible uniquement à l'utilisateur "boris.parejo"
  {
    path: '/admin',
    component: AdminLayout,
    meta: { requiresAuth: true, requiresAdmin: true },
    children: [
      {
        path: '',
        redirect: '/admin/mandants'
      },
      {
        path: 'mandants',
        name: 'AdminMandators',
        component: AdminMandators,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'dernieres-visites',
        name: 'AdminDernieresVisites',
        component: AdminDernieresVisites,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'database-sync',
        name: 'DatabaseSync',
        component: DatabaseSync,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'visit-sync-mssql',
        name: 'VisitSyncToMssql',
        component: VisitSyncToMssql,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'doublons-visites',
        name: 'DoublonsVisites',
        component: DoublonsVisites,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'import-photos',
        name: 'PhotoImport',
        component: PhotoImport,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'sql-query',
        name: 'SqlQuery',
        component: SqlQuery,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'api-explorer',
        name: 'ApiExplorer',
        component: ApiExplorer,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'techniciens-visites',
        name: 'AdminVisitManagers',
        component: AdminVisitManagers,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'doublons-lots',
        name: 'AdminPropertyDuplicates',
        component: AdminPropertyDuplicates,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'nettoyage-visites',
        name: 'AdminVisitsCleanup',
        component: AdminVisitsCleanup,
        meta: { requiresAuth: true, requiresAdmin: true }
      },
      {
        path: 'photos-base64',
        name: 'AdminBase64PhotosFix',
        component: AdminBase64PhotosFix,
        meta: { requiresAuth: true, requiresAdmin: true }
      }
    ]
  },

  // ── Dossiers / lots ──────────────────────────────────────────────────────
  {
    path: '/dossier/:id',
    component: LotLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        redirect: to => `/dossier/${to.params.id}/timeline`
      },
      {
        path: 'informations',
        name: 'folder',
        component: Informations,
        meta: { requiresAuth: true }
      },
      {
        path: 'timeline',
        name: 'timeline',
        component: Timeline,
        meta: { requiresAuth: true }
      },
      {
        path: 'actions-et-travaux',
        name: 'actions-et-travaux',
        component: ActionsAndWorks,
        meta: { requiresAuth: true }
      },
      {
        path: 'nouvelle-visite',
        name: 'new-visit',
        component: NewVisit,
        meta: { requiresAuth: true }
      },
      {
        path: 'nouveau-pre-chiffrage',
        name: 'new-pre-chiffrage',
        component: NewPreChiffrage,
        meta: { requiresAuth: true }
      },
      {
        path: 'fiche/:visitId',
        name: 'ficheVisite',
        component: Visit,
        meta: { requiresAuth: true }
      },
      {
        path: 'pre-chiffrage/:preChiffrageId',
        name: 'view-pre-chiffrage',
        component: ViewPreChiffrage,
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard : authentification + contrôle d'accès admin
router.beforeEach(async (to, from, next) => {
  let isLoggedIn = store.getters['login/isLoggedIn']

  if (to.meta.requiresAuth) {
    if (!isLoggedIn) {
      try {
        const initialized = await store.dispatch('login/initializeAuth')
        if (!initialized) {
          next({ name: 'connexion', query: { from: to.fullPath } })
          return
        }
        isLoggedIn = true
      } catch (error) {
        console.error('Erreur lors de l\'initialisation:', error)
        next({ name: 'connexion', query: { from: to.fullPath } })
        return
      }
    }

    // ── Vérification de l'accès à la zone d'administration ──────────────────
    if (to.meta.requiresAdmin) {
      try {
        const dexieService = (await import('../services/dexieService')).default
        const user = await dexieService.getUser()
        if (!user || user.username !== 'boris.parejo') {
          console.warn(`Accès refusé à ${to.path} : réservé à l'administrateur`)
          next({ name: 'home' })
          return
        }
      } catch (error) {
        console.error('Erreur vérification accès admin:', error)
        next({ name: 'home' })
        return
      }
    }

    // ── Vérification du rôle ROLE_ADMIN si nécessaire ───────────────────────
    if (to.meta.requiresRole) {
      try {
        const dexieService = (await import('../services/dexieService')).default
        const user = await dexieService.getUser()
        const roles = (user && user.roles) ? user.roles : []
        const requiredRole = to.meta.requiresRole
        if (!roles.includes(requiredRole)) {
          console.warn(`Accès refusé à ${to.path} : rôle ${requiredRole} requis`)
          next({ name: 'home' })
          return
        }
      } catch (error) {
        console.error('Erreur vérification rôle:', error)
        next({ name: 'home' })
        return
      }
    }

    next()
  } else if (to.name === 'connexion') {
    if (isLoggedIn) {
      next({ name: 'home' })
    } else {
      try {
        const initialized = await store.dispatch('login/initializeAuth')
        if (initialized) {
          next({ name: 'home' })
          return
        }
      } catch (error) {
        console.error('Erreur lors de l\'initialisation:', error)
      }
      next()
    }
  } else {
    next()
  }
})

export default router
